import { ScoreBand } from '../../../store/callStats/callStatsTypes';
import {
  customError,
  lightTeal,
  successGreenAlt,
  warningYellow,
} from '../../../mainTheme';

export const bandColor: Record<ScoreBand, string> = {
  excellent: successGreenAlt,
  good: lightTeal,
  fair: warningYellow,
  poor: customError,
};

export const bandLabel: Record<ScoreBand, string> = {
  excellent: 'Excellent',
  good: 'Good',
  fair: 'Fair',
  poor: 'Poor',
};

// recharts-friendly categorical palette (call type, ICE type, statuses).
export const CHART_COLORS = [
  '#865E9C', // lightPurple
  '#6BCABA', // lightTeal
  '#FA881E', // orange
  '#DB5543', // customError
  '#250E62', // darkPurple
  '#FCCC32', // warningYellow
];
